import React, { Component } from 'react';
import Summary from '../components/Summary';
import JuncalSummary from './JuncalSummary';
import ContractsContainer from '../containers/ContractsContainer';
import { Col, Row } from 'react-bootstrap';
import withAuthControl from '../auth/Auth.js';
import TopScrolleable from './TopScrolleable.js'
import Section from './Section.js'

class CheckOut extends Component {

    render() {

        let summaryComponent;

        switch(process.env.PAGE){
            case 'juncal':
                summaryComponent = (<JuncalSummary/>);
                break;
            default:
                summaryComponent = (<Summary/>)
        }

        return (
            <Section className="intro_form">
                <div className="pvc-form checkout">
                    <Row>
                        <Col xs={12} md={8} lg={5}>
                            {summaryComponent}
                        </Col>
                        <Col xs={12} md={4} lg={7}>
                            <Row>
                                <Col xs={12} md={4} lg={1}>
                                </Col>
                                <Col xs={12} md={4} lg={11}>
                                    <ContractsContainer/>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>
            </Section>
        );
    }
}

CheckOut = TopScrolleable(CheckOut);
CheckOut = withAuthControl(CheckOut);
export default CheckOut;



/** WEBPACK FOOTER **
 ** ./src/components/CheckOut.js
 **/